import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AppConfigService {
	config: any;

	constructor(
		private readonly http: HttpClient
	) { }

	async loadAppConfig(): Promise<any> {
		const assignConfig = (config: any) => this.config = config;

		return firstValueFrom(
			this.http.get('/finance/payment-calculator/assets/config/appconfig.json')
		).then(assignConfig);
	}

	getBaseEndpoint(): any {
		return environment.lincolnPeWebKey;
	}
}
